<template>
  <div>
    <top-navbar></top-navbar>
    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        <router-link class="decoration" to="/tinternalcourses/scheduled">Scheduled Internal Courses</router-link><span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        View Training Survey
      </h6>
      <div class="container-fluid">
        <div class="d-flex justify-content-end mb-1">
          <button type="button" class="btn btn-sm btn-outline-primary bdr-rad font-size_def" @click="goBack">Back</button>
        </div>
        <div class="card custom_bdr_rds shadow p-2" v-if="isLoading"><div class="card-body custom_bdr_rds"><div class="d-flex justify-content-center"><div class="spinner-border text-primary"></div></div></div></div>
        <div v-else class="card custom_bdr_rds shadow p-2">
          <div class="card-body custom_bdr_rds">
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div class="card custom_bdr_rds p-2">
              <div class="card-body custom_bdr_rds">
                <div class="form-group"><label class="custom-label text-dark">Share Link</label><input :value="shareLink" class="form-control form-control-sm bdr-rad" readonly></div>
              </div>
            </div>
            <div class="card custom_bdr_rds shadow p-2 mt-2">
              <div class="card-body custom_bdr_rds">
                <h6 class="purchitem mb-2"><b>Survey Question</b></h6>
                <div class="d-flex justify-content-between mb-2"><span class="text-muted small">Showing {{ details.length }} items.</span></div>
                <div class="table-responsive">
                  <table class="table table-hover table-sm table-borderless">
                    <thead class="background_color2"><tr class="custom-label2"><th>#</th><th>Category</th><th>Question</th><th>Remarks</th></tr></thead>
                    <tbody>
                      <tr v-for="(detail, index) in details" :key="detail.id">
                        <td>{{ index + 1 }}</td><td>{{ detail.category || '-' }}</td><td>{{ detail.question }}</td><td>{{ detail.remarks || '-' }}</td>
                      </tr>
                      <tr v-if="!details.length"><td colspan="4" class="text-muted">No survey questions found.</td></tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="message" class="alert alert-info mt-2 mb-0">{{ message }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() { return { token: authService.isLoggedIn(), isLoading: true, errorMessage: '', message: '', allData: {}, details: [] }; },
  computed: { scheduleId() { return this.$route.query.schedule_id || this.$route.query.id; }, shareLink() { return window.location.origin + '/tinternalcourses/scheduled/survey?schedule_id=' + this.scheduleId; } },
  mounted() { this.loadSurvey(); },
  methods: {
    async loadSurvey() { try { const { data } = await axios.get('/ticourses/scheduled-survey?id=' + this.scheduleId, { headers: { Authorization: 'Bearer ' + this.token } }); this.allData = data.schedule || {}; this.details = data.questions || []; } catch (error) { this.errorMessage = 'Unable to load saved survey questions.'; } finally { this.isLoading = false; } },
    goBack() { this.$router.push('/tinternalcourses/scheduled'); },
  },
};
</script>
